const OMNI_SEARCH_DATASOURCE = 'index_ds_d71d6026';

function getFunLinkSdk() {
  if (typeof window === 'undefined' || !window.FUN_LINK_SDK) {
    return Promise.reject({
      status: -1,
      msg: 'Fun Link SDK 未加载'
    });
  }

  return Promise.resolve(window.FUN_LINK_SDK);
}

function getResponseData(response) {
  if (response.status !== 0 /*非成功返回*/) {
    return Promise.reject(response);
  }

  return response.data;
}

function normalizePositionData(data) {
  if (!Array.isArray(data?.items)) {
    return data;
  }

  return data.items.reduce((positionMap, positionItem) => {
    const positionId = positionItem.position || positionItem.positionId;
    if (!positionId) {
      return positionMap;
    }

    positionMap[positionId] = (positionItem.dataSource || []).reduce((dataSourceMap, dataSourceItem) => {
      const dataSourceId = dataSourceItem.datasource || dataSourceItem.datasourceId;
      if (!dataSourceId) {
        return dataSourceMap;
      }

      const { datasource, datasourceId, ...dataSourceData } = dataSourceItem;
      dataSourceMap[dataSourceId] = dataSourceData;
      return dataSourceMap;
    }, {});
    return positionMap;
  }, {});
}

/**
 *  获取omni数据
 * @param {*} postion 分发位置
 * @returns
 */
export function getOmniData(postion, dataSources) {
  return getFunLinkSdk()
    .then(sdk =>
      sdk.getOmniPositionData({
        param: {
          lang: 'zh-Hans',
          positions: [
            {
              dataSources: dataSources,
              position: postion
            }
          ]
        }
      })
    )
    .then(getResponseData)
    .then(normalizePositionData)
    .then(data => data?.[postion]);
}

export function getOmniDetail(contentId) {
  return getFunLinkSdk()
    .then(sdk =>
      sdk.getOmniDetail({
        param: {
          lang: 'zh-Hans',
          contentId: contentId
        }
      })
    )
    .then(getResponseData)
    .then(data => data?.content || data?.[contentId]);
}

export const geyOmniSearch = ({ keywords, categoryId = '', page = 1, pageSize = 10 }) => {
  const params = {
    _omni_withDict: true,
    _omni_aggField: 'categoryId',
    _omni_text: keywords,
    page,
    pageSize
  };
  if (categoryId) {
    params.categoryId = categoryId;
  }

  return getFunLinkSdk()
    .then(sdk => sdk.getOmniSearchDatasource(OMNI_SEARCH_DATASOURCE, params))
    .then(getResponseData);
};

export const newData = [
  { title: '最新', spaceTitle: '最&nbsp;&nbsp;新', id: 'ds_cat_b996545c' },
  { title: '新闻', spaceTitle: '新&nbsp;&nbsp;闻', id: 'ds_cat_5c6a3116' },
  { title: '公告', spaceTitle: '公&nbsp;&nbsp;告', id: 'ds_cat_16359372' },
  { title: '活动', spaceTitle: '活&nbsp;&nbsp;动', id: 'ds_cat_72189bb8' }
];

export const strategy = {
  ds_cat_1d928b4b: {
    title: '最新',
    spaceTitle: '最&nbsp;&nbsp;新',
    categoryId: '',
    imgIndex: 0
  },
  ds_cat_c19c1ad2: {
    title: '新手',
    spaceTitle: '新&nbsp;&nbsp;手',
    categoryId: 'sqrihgmc2yo1',
    imgIndex: 1
  },
  // 门派入口已隐藏(数据保留, 兼容旧链接), imgIndex 与玩法保持原 tab 图下标
  ds_cat_ad2344d7: {
    title: '门派',
    spaceTitle: '门&nbsp;&nbsp;派',
    categoryId: 'sqrihphz37k2',
    imgIndex: 2,
    hidden: true
  },
  ds_cat_fd05e1f7: {
    title: '玩法',
    spaceTitle: '玩&nbsp;&nbsp;法',
    categoryId: 'sqrii0cn7if5',
    imgIndex: 3
  }
  // ds_cat_f7340f6f: {
  //   title: '进阶',
  //   spaceTitle: '进&nbsp;&nbsp;阶',
  //   categoryId: 'sqrii98a7rb5'
  // }
};
